import React, { useEffect, useState } from "react";
import {
  Button,
  Grid,
  //   Paper,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Box,
  Alert,
} from "@mui/material";
import { useSelector } from "react-redux";
import { labels } from "../../../lang/labels";
import FormTitle from "../../form-fields/form-title";
import DashBoardContainer from "../../layout/dashboard-container";
import { GridRow } from "../counter/generate-receipt/custom-form-grid";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ConfirmationDialog from "../../form-fields/confirm-dialog";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import {
  approveCancelReceipt,
  getZoCancelReceipts,
} from "../../../services/cancel-receipt-service";
import Loader from "../../loader/loader";
import { showToastError, showToastSuccess } from "../../common/toastHelper";
import { getErrorMsg } from "../../../utils/helpers";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#e6eaeb",
    fontWeight: "600",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const CancelReceiptDashboard = () => {
  const lang = useSelector((state) => state.userDetails.lang);
  const [open, setOpen] = useState(false);
  const [receipts, setReceipts] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [receiptToApprove, setReceiptToApprove] = useState("");
  const [confirmationDialogText, setConfirmationDialog] = useState({
    title: "Confirm Action",
    description: "Are you sure you want to approve cancelled receipt?",
  });

  useEffect(() => {
    const getData = async () => {
      try {
        setIsLoading(true);
        const res = await getZoCancelReceipts();
        setReceipts(res);
      } catch (error) {
        showToastError(getErrorMsg(error));
      } finally {
        setIsLoading(false);
      }
    };
    if (!receipts) {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOpen = (receiptno, receipttype) => {
    setReceiptToApprove({
      receiptno,
      receipttype: receipttype.replace(/\s+/g, ""),
    });
    setOpen(true);
    setConfirmationDialog({
      title: `Confirm Receipt No. #${receiptno}`,
      description: "Are you sure you want to approve this receipt?",
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleApprove = async () => {
    // Add your approve logic here
    setIsLoading(true);
    try {
      await approveCancelReceipt(receiptToApprove);
      showToastSuccess();
      window.location.reload();
    } catch (error) {
      showToastError(getErrorMsg(error));
    } finally {
      setIsLoading(false);
      setOpen(false);
    }
  };
  return (
    <DashBoardContainer>
      {isLoading && <Loader />}
      {error && (
        <Alert
          sx={{
            padding: "0px",
            paddingLeft: "10px",
            paddingRight: "10px",
            marginTop: "15px",
          }}
          severity="error"
          onClose={() => {
            setError("");
          }}
        >
          {error}
        </Alert>
      )}
      {receipts?.lst?.length === 0 && (
        <Alert severity="warning">
          You don't have cancelled receipt for Approval.
        </Alert>
      )}
      <FormTitle title={labels.CancelReceiptDashboard[lang]} />
      {receipts && (
        <Grid sx={{ paddingTop: "20px" }}>
          <ConfirmationDialog
            open={open}
            title={confirmationDialogText.title}
            description={confirmationDialogText.description}
            handleClose={handleClose}
            handleApprove={handleApprove}
          />

          <GridRow>
            <Box sx={{ overflow: "auto", width: "100%" }}>
              <Table
                size="small"
                sx={{ minWidth: 650 }}
                aria-label="simple table"
              >
                <TableHead>
                  <StyledTableRow
                    sx={{
                      background: "#e6eaeb",
                      "&:last-child td, &:last-child th": { border: 1 },
                      border: 1,
                      fontSize: "12px",
                    }}
                  >
                    <StyledTableCell align="center">
                      {labels.PropertyCode[lang]}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {labels.PropertyName[lang]}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {labels.ReceiptDate[lang]}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {labels.ReceiptNumber[lang]}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {labels.ModeOfPayment[lang]}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {labels.Amount[lang]}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {labels.Remark[lang]}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {labels.ReceiptType[lang]}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {labels.Action[lang]}
                    </StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody sx={{ border: 1 }}>
                  {receipts.lst.map((item, index) => {
                    return (
                      <StyledTableRow key={index}>
                        <StyledTableCell align="center">
                          {item.propertycode}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {item.propertyname}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {item.receiptDate}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {item.receiptno}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {item.modeofpayment}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {item.paidamount}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {item.remark}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {item.receipttype}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <Button
                            variant="contained"
                            color="success"
                            onClick={() => {
                              handleOpen(item.receiptno, item.receipttype);
                            }}
                            size="small"
                            startIcon={<CheckCircleIcon />}
                          >
                            Approve
                          </Button>
                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </GridRow>
        </Grid>
      )}
    </DashBoardContainer>
  );
};

CancelReceiptDashboard.propTypes = {};

export default CancelReceiptDashboard;
